module.exports = __webpack_public_path__ + "img/arrows-expand.aab96d85.svg";